export default {
    START: 'start',
    QUESTIONS: 'questions',
    RESULT: 'result'
}